import { useQuery } from '@tanstack/react-query';
import { User } from 'src/features/auth/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/users/user/';

type QueryFnType = typeof queryFn;
const queryFn = (params: ListDTO): Promise<ListResponseSmartParkAPI<User>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends ListDTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...params }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE],
        queryFn: async () => await queryFn(params),
        ...config,
    });

export { RESOURCE as LIST_USERS_RESOURCE, queryFn as listUsers, useQueryHook as useListUsers };
